import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

export interface Functionality {
  fnname: string;
  fncode: string;
}

@Injectable({ providedIn: 'root' })
export class RolesApiService {
  private api = inject(VwApiRequestsService);

  list() {
    return this.api.getAPICall('/roles');
  }

  getFunctionalities() {
    return this.api.getAPICall('/roles/functionalities');
  }

  create(payload: { role_name: string; functionalities: Functionality[] }) {
    return this.api.postAPICall('/roles', payload);
  }

  update(id: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/roles/${id}`, payload);
  }

  delete(id: string) {
    return this.api.postAPICall(`/roles/${id}/delete`, {});
  }
}
